'use client';
import { useTranslations } from 'next-intl';
import { CatIconInfo, CatButton } from 'components/blocks-components';
import { TooltipPosition } from '@blocks-web-components/components/tooltip/tooltip.model';
import { useDrawer } from '@cat-ecom/pcc-components';
import ProductCoreDepositTooltip from './product-core-deposit-tooltip';
import ProductCoreDepositDrawer from './product-core-deposit-drawer';
import styles from './product-core-desposit.module.scss';
import cx from 'classnames';

interface ProductCoreDepositProps {
  coreCharges: string;
  currency: string;
  withBorder?: boolean;
  tooltipPosition?: TooltipPosition;
  isMobileTooltipDrawer?: boolean;
}

const TooltipTrigger = ({ onClick }: { onClick?: () => void }) => {
  const t = useTranslations();

  return (
    <CatButton
      variant="ghost"
      slot={!onClick && 'trigger'}
      onClick={onClick}
      className={styles['product-core-deposit__tooltip-trigger']}
      data-testid="trigger-button"
    >
      <CatIconInfo className="me-1" color="information" />
      <span className="cat-u-theme-typography-label-sm">
        {t('CAT_CORE_DEPOSIT_TITLE')}
      </span>
    </CatButton>
  );
};

const ProductCoreDeposit = ({
  coreCharges,
  currency,
  withBorder = true,
  tooltipPosition = 'top',
  isMobileTooltipDrawer = false
}: ProductCoreDepositProps) => {
  const { closeDrawer, drawerProps, openDrawer } = useDrawer();
  const PCDdrawerProps = {
    closeDrawer,
    ...drawerProps
  };

  return (
    <div
      className={cx('d-flex flex-column', {
        'py-2': withBorder,
        [styles['product-core-deposit__container']]: withBorder
      })}
    >
      {isMobileTooltipDrawer && (
        <div className="d-block d-md-none">
          <TooltipTrigger onClick={openDrawer} />
          <ProductCoreDepositDrawer drawerProps={PCDdrawerProps} />
        </div>
      )}
      <ProductCoreDepositTooltip
        tooltipPosition={tooltipPosition}
        isMobileTooltipDrawer={isMobileTooltipDrawer}
      >
        <TooltipTrigger />
      </ProductCoreDepositTooltip>
      <p className={cx('mt-1 mb-0', styles['product-core-deposit__price'])}>
        <span className="cat-u-theme-typography-label-sm">{coreCharges}</span>
        <span className="cat-u-theme-typography-footnote"> {currency}</span>
      </p>
    </div>
  );
};

export default ProductCoreDeposit;
